export type SaveAttempt = "create" | "update" | "skip";

/**
 * Resolve what a Save click may do without relying only on React render state.
 * A successful create is committed to a ref before the state update renders;
 * during that gap, stale callbacks must skip instead of creating map two.
 */
export function resolveSaveAttempt(input: {
  inFlight: boolean;
  hasRenderedShare: boolean;
  hasCommittedShare: boolean;
}): SaveAttempt {
  if (input.inFlight) return "skip";
  if (input.hasRenderedShare) return "update";
  if (input.hasCommittedShare) return "skip";
  return "create";
}
